import React, { Component } from 'react';
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { getQuery } from './utils';

class ErrorBoundary extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }

  componentDidMount(){
    
  }

  logError(error, errorInfo){
    const params = getQuery();
    if(params.debug){
      alert(JSON.stringify(error));
      alert(JSON.stringify(errorInfo));
    }
    console.log(error);
    console.log(errorInfo);
  }

  componentDidCatch(error, errorInfo){
    this.logError(error, errorInfo);
    this.setState({error, errorInfo});
  }

  locationDidChange(){
    this.setState({error: null, errorInfo: null});
  }

  render(){
    if(this.state.error){
      return <><LocationWatcher onChange={this.locationDidChange.bind(this)} /><p>An unexpected error occurred. Please try again later.</p></>
    }
    return this.props.children;
  }

}

function LocationWatcher (props) {
  const location = useLocation();
  const [ prevLocation, setPrevLocation ] = React.useState(null);
  useEffect(() => {
    if (location !== prevLocation && prevLocation !== null) {!
      props.onChange();
    }
    setPrevLocation(location);
  }, [location]);
  return null;
}

export default ErrorBoundary;